"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderFlickity = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_flickity_component_1 = __importDefault(require("react-flickity-component"));
var react_1 = require("react");
exports.SliderFlickity = (0, react_1.memo)(function (_a) {
    var children = _a.children, _b = _a.loop, loop = _b === void 0 ? true : _b, _c = _a.cellAlign, cellAlign = _c === void 0 ? 'center' : _c, _d = _a.draggable, draggable = _d === void 0 ? '>1' : _d, _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.onLoad, onLoad = _f === void 0 ? null : _f, _g = _a.buttons, buttons = _g === void 0 ? false : _g, _h = _a.pageDots, pageDots = _h === void 0 ? true : _h, _j = _a.freeScroll, freeScroll = _j === void 0 ? true : _j, _k = _a.changePosition, changePosition = _k === void 0 ? null : _k, _l = _a.onStaticClick, onStaticClick = _l === void 0 ? null : _l, onChange = _a.onChange, _m = _a.groupCells, groupCells = _m === void 0 ? false : _m, _o = _a.autoPlay, autoPlay = _o === void 0 ? false : _o, _p = _a.arrowShape, arrowShape = _p === void 0 ? null : _p;
    var _q = __read((0, react_1.useState)(null), 2), flikifly = _q[0], setFliki = _q[1];
    var options = __assign({ autoPlay: autoPlay, cellAlign: cellAlign, contain: !loop, freeScroll: freeScroll, dragThreshold: 5, groupCells: groupCells, imagesLoaded: false, initialIndex: 0, lazyLoad: 1, pageDots: pageDots, prevNextButtons: buttons, resize: true, wrapAround: loop, draggable: draggable }, (arrowShape && { arrowShape: arrowShape }));
    (0, react_1.useEffect)(function () {
        if (flikifly) {
            flikifly.resize();
            setTimeout(function () {
                onLoad && onLoad();
                setTimeout(function () { return flikifly.resize(); }, 1000);
            }, 1500);
        }
    }, [flikifly, children, onLoad]);
    (0, react_1.useEffect)(function () {
        if (!changePosition || !flikifly)
            return;
        flikifly.selectCell(changePosition, false, true);
    }, [changePosition]);
    (0, react_1.useEffect)(function () {
        if (onStaticClick && flikifly) {
            flikifly.on('staticClick', onStaticClick);
            return function () { return flikifly.off('staticClick', onStaticClick); };
        }
    }, [onStaticClick, flikifly]);
    (0, react_1.useEffect)(function () {
        if (onChange && flikifly) {
            flikifly.on('change', onChange);
            return function () { flikifly.off('change', onChange); };
        }
    }, [flikifly]);
    // DragMove & DragEnd avoid missclicks on links while dragging
    // CSS styles in the reset.ts
    (0, react_1.useEffect)(function () {
        function dragMove() {
            document.ontouchmove = function () { return false; };
            document.body.classList.add('slider-being-dragged');
        }
        if (flikifly) {
            flikifly.on('dragMove', dragMove);
            return function () { return flikifly.off(dragMove); };
        }
    }, [flikifly]);
    (0, react_1.useEffect)(function () {
        function dragStart() {
            document.ontouchmove = function () { return false; };
        }
        if (flikifly) {
            flikifly.on('dragStart', dragStart);
            return function () { return flikifly.off(dragStart); };
        }
    }, [flikifly]);
    (0, react_1.useEffect)(function () {
        function dragEnd() {
            document.ontouchmove = function () { return true; };
            setTimeout(function () {
                document.body.classList.remove('slider-being-dragged');
            }, 50);
        }
        if (flikifly) {
            flikifly.on('dragEnd', dragEnd);
            return function () { return flikifly.off(dragEnd); };
        }
    }, [flikifly]);
    return (
    //@ts-ignore
    (0, jsx_runtime_1.jsx)(react_flickity_component_1.default, __assign({ reloadOnUpdate: true, flickityRef: function (ref) { return setFliki(ref); }, className: 'slider--flickity ' + className, elementType: 'div', options: options }, { children: children })));
});
